export class PropertiesReplication {
  name: string;
  displayName: string;
  description: string;
  startDate: string;
  nextRunTime: string;
}
